import { render, staticRenderFns } from "./VFileUploader.vue?vue&type=template&id=07c87e86&"
import script from "./VFileUploader.vue?vue&type=script&lang=js&"
export * from "./VFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./VFileUploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports